import React, { Component } from 'react';

import { AuthContext } from "../../authContext";
import Button from "../shared/Button";
import {createProjectResource, getResourceUploadToken} from "../data/dataCIMToolkit";
import DismissButton from "../shared/DismissButton";
import Flex from "../shared/Flex";
import FormContainer from "../shared/form/FormContainer";
import FormLabel from "../shared/form/FormLabel";
import PageHeading from "../shared/PageHeading";
import TextInput from "../shared/form/TextInput";

class AddResource extends Component {
  state = {
    name: "",
    isSaving: false,
    isShowDetails: false
  };
  static contextType = AuthContext;
  handleAddResource = async e => {
    e.preventDefault();
    await this.setState({isSaving: true});

    // let name = this.state.name;
    // let suffix = name.substr(suffix.length - 5);

    // @TODO - check whether user has already entered a .curb or .urb suffix and replace it with .curb

    const newResourceData = {
      name: `${this.state.name}.curb`,
      projectID: this.props.projectID,
      type: 'application/urb'
    };

    let addResourceResponse = await createProjectResource(newResourceData, this.context.token);

    //console.log("AddResource > addResourceResponse ", addResourceResponse);

    const newResourceID = addResourceResponse.data.resourceID;
    await this.setState({isSaving: false});

    const resourceUploadTokenResponse = await getResourceUploadToken(newResourceID, this.context.token);

    // console.log("AddResource > resourceUploadTokenResponse", resourceUploadTokenResponse);
    const resourceData = resourceUploadTokenResponse.data.resourceData;
    const url = resourceUploadTokenResponse.data.url;

    this.props.toggleForm();
    await this.props.requestUploadFromCityCAD(resourceData, url);
  };
  handleTextInputChange = e => { this.setState({ [e.target.name]: e.target.value }); };
  toggleShowDetails = async () => {
    await this.setState({isShowDetails: !this.state.isShowDetails});
  };
  render() {
    return (
      <FormContainer>
        <DismissButton toggleForm={this.props.toggleForm} />
        <PageHeading small>Add CityCAD model</PageHeading>
        <p>This will save your current CityCAD model to this project.</p>
        <div style={{textAlign: "center"}}>
          <form>
            <Flex style={{maxWidth: "500px"}}>
              <FormLabel htmlFor="inputFileName">File name</FormLabel>
              <TextInput type="text" name="name" id="inputName" value={this.state.username} onChange={this.handleTextInputChange} />
            </Flex>
            <div style={{maxWidth: "500px", textAlign: "right", marginTop: "7px"}}>
              <Button type="submit" onClick={this.handleAddResource}>Save</Button>
            </div>
          </form>
        </div>
        <p style={{color:"#ff0000"}}>{this.context.isErrorAuthenticating && "Please check your username and password"}</p>
        <p style={{textAlign:"right", marginRight: "30px"}}>
          {
            <span style={{cursor:"pointer"}} onClick={this.toggleShowDetails}>
              {
                this.state.isShowDetails
                ?
                `Hide details`
                :
                `What\u2019s this?`
              }
            </span>
          }
        </p>
        {
          this.state.isShowDetails
          &&
          <div>
            <h3>What's this?</h3>
            <ul>
              <li>In CityCAD 3.0 you can now save CityCAD models to a private cloud storage area.</li>
              <li>Your model will be stored in <strong>curb</strong> (compressed urban model) format, which is a smaller version of the URB format.</li>
              <li>You can open and save models by going to the 'Resources' tab above.</li>
              <li>
                <strong>
                  Please note that if any other contacts have been added to your account, they will be able to view, download and edit models saved here.
                </strong>
              </li>
            </ul>
            <span style={{cursor:"pointer"}} onClick={() => this.context.navigate(`/account`)}>
              Click here to see your account details (including other team members on your account, if any)
            </span>

          </div>
        }
      </FormContainer>
    );
  }
}

export default AddResource;
